export default {
  oneFr: 1,
  twoFr: 2,
  threeFr: 3,
  fourFr: 4
}
